module.exports = __webpack_public_path__ + "img/Lucky_wheel.a583c624.png";